import {useEffect, useState} from "react";
import {EmployeeList, ScrapingCodeList as List} from "../components";
import { useTranslation } from "react-i18next";
import useScrapingCodes from "../hooks/useScrapingCodes";
import ImportModal from "../components/ImportModal";
import { ScrapingCodeFormContainer as FormContainer } from "./ScrapingCodeFormContainer";
import {useImportModal} from "../hooks/useImportModal";
import {useToaster} from "../context-providers/ToasterProvider";
import {useSelector} from "react-redux";
import {apiUrlSelector} from "../redux/selectors";
import {useDeleteModal} from "../hooks/useDeleteModal";
import {apiUrls} from "../common/apiUrls";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";

export const ScrapingCodesContainer = () => {

    const {t} = useTranslation(["ScrapingCodesContainer", "Buttons"]);

    const apiUrl = useSelector(apiUrlSelector);

    const { toastError } = useToaster();

    const [recordId, setRecordId] = useState(0);

    const [showRecordModal, setShowRecordModal] = useState(false);

    const { isLoading, error, data } =  useScrapingCodes();

    useEffect( ( ) => {
        if ( error ) {
            toastError(t("errorFetchingCodes"));
        }
    }, [error] );

    const { modal: importModal, onImportClick } = useImportModal("url fo importu");

    const { confirmDelete, ...deleteModalProps } = useDeleteModal(apiUrls.scrappingCodes);
    
    const handleCloseRecordModal = () => setShowRecordModal(false);

    const handleAddClick = () => {
        
        setRecordId(0);
        setShowRecordModal(true);

    };

    const handleEditClick = row => {
        setRecordId(row.id);
        setShowRecordModal(true);

    };

    const handleHistoryClick = (item) => {
        console.log("Pokazuję historię", item);
    };
    
    return (
        <>
            {showRecordModal && <FormContainer recordId={recordId}
                                               onSave={handleCloseRecordModal}
                                               onCancelClick={handleCloseRecordModal}
                                               onGetError={handleCloseRecordModal} />}

            <ImportModal {...importModal} />

            <ConfirmDeleteModal {...deleteModalProps} />
            
            <List records={data} loading={isLoading} onAddClick={handleAddClick}
                  onEditClick={handleEditClick} onDeleteClick={confirmDelete} onHistoryClick={handleHistoryClick}
                  onImportClick={onImportClick} exportHref={`${apiUrl}/scraping-codes/export"`} />
        </>
    );
};

export default ScrapingCodesContainer;